<div class="select-dialog"
     [@.disabled]="true">
    <div class="select-dialog__header">
        <h3 class="select-dialog__title">{{data.fieldConfig.caption | translate}}</h3>
        <mat-form-field *ngIf="searchVisible">
            <input type="text"
                   #searchInput
                   matInput
                   tabindex="-1"
                   [placeholder]="selectSearchText | translate"
                   (input)="filterValues($event.target.value)">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>

    <ng-container *ngIf="datepickerMode; else standardList">
        <ng-template *ngTemplateOutlet="datepickerList"></ng-template>
    </ng-container>

    <div class="select-dialog__footer" (click)="closeSelect()">
        {{ 'SELECT_DIALOG_COMPONENT.close' | translate}}
    </div>
</div>

<ng-template #standardList>
    <mat-list class="select-dialog__list">
        <ng-container *ngFor="let item of filteredItems">
            <mat-list-item class="select-dialog__list-item"
                           (click)="closeSelect(item)"
                           [ngClass]="{'select-dialog__selected-item': isItemSelected(item)}">
                <ng-container [ngSwitch]="data.fieldConfig.options.template">
                    <ng-container *ngSwitchCase="data.templateOptions.eurotax">
                        <app-vehicle-version [item]="item"></app-vehicle-version>
                    </ng-container>
                    <ng-container *ngSwitchCase="data.templateOptions.infoexpert">
                        <app-vehicle-version [item]="item"></app-vehicle-version>
                    </ng-container>
                    <ng-container *ngSwitchCase="data.templateOptions.model">
                        <app-vehicle-model-list-item [item]="item"></app-vehicle-model-list-item>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{  data.translateLabel ? (getConcatLabel(item) | translate) : getConcatLabel(item) }}
                    </ng-container>
                </ng-container>
            </mat-list-item>
        </ng-container>
        <div *ngIf="noResults"
             class="select-dialog__empty-state">
            {{ noResultsText | translate}}
        </div>
        <div *ngIf="loading" class="select-dialog__empty-state">{{ data.loadingText | translate }}</div>
    </mat-list>
</ng-template>

<ng-template #datepickerList>
    <app-select-datepicker-list *ngIf="filteredItems && filteredItems.length"
                                [items]="filteredItems"
                                (itemSelected)="onDatepickerItemSelected($event)"
                                [viewConfig]="datepickerViewConfig">
    </app-select-datepicker-list>
</ng-template>
